import {IMAGE_SERVICE, USER_SERVICE} from "../reduxToolkit/EndPoints";

/**
 * The full information of the user in session is read again when an image is saved, so its photo
 * is refreshed. An image is saved in two requests, the record and then the file, and only the
 * images of the user in session need the refresh: the ones of other users, such as the ones of an
 * employee or a guard being enrolled, are skipped.
 */

// Records created for other users, the upload of their file is skipped once
const otherUsersImageIds = new Set();

const readJson = (data) => {
    try {
        return typeof data === 'string' ? JSON.parse(data) : data;
    } catch (e) {
        return null;
    }
};

/**
 * @param {Object} response - Successful axios response.
 * @returns {boolean} Whether the full information of the user in session has to be read again.
 */
export const shouldRefreshSessionUser = (response) => {
    const url = response?.config?.url;

    if (url === USER_SERVICE.createImgObj) {
        const ownerId = readJson(response.config.data)?.user?.id;
        if (ownerId && ownerId !== sessionStorage.getItem('id')) {
            const imageId = response?.data?.data?.id;
            if (imageId) otherUsersImageIds.add(imageId);
            return false;
        }
        return true;
    }

    if (url === IMAGE_SERVICE.uploadImage) {
        const imageId = response?.config?.data instanceof FormData ? response.config.data.get('id') : null;
        if (imageId && otherUsersImageIds.has(imageId)) {
            otherUsersImageIds.delete(imageId);
            return false;
        }
        return true;
    }

    return false;
};
